<!--
  @author:sunluhua
  @time:2020/9/14
  @disc:销售计划导出3
 -->
<template>
  <div class="sale-query">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="80px">
      <el-form-item label="单据编号" prop="ces1">
        <el-input v-model="form.ces1" placeholder="请输入单据编号"></el-input>
      </el-form-item>
      <el-form-item label="调账类型" prop="ces2">
        <el-select v-model="form.ces2" placeholder="请选择">
          <el-option
            v-for="item in orderType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="币种" prop="ces3">
        <el-select v-model="form.ces3" placeholder="请选择">
          <el-option
            v-for="item in moneyType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="经营组织" prop="ces4">
        <ajax-select
          v-model="form.organization"
          type="org"></ajax-select>
      </el-form-item>
      <el-form-item label="客户名称" prop="ces5">
        <search-select
          v-model="form.custom"
          type="customer"
          valueField="id"
          clearable
          placeholder="请输入客户名称"></search-select>
      </el-form-item>
      <el-form-item label="审核状态" prop="auditStatus">
        <el-select v-model="form.auditStatus" placeholder="请选择">
          <el-option
            v-for="item in auditType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="推送电子报账状态" prop="status">
        <el-select v-model="status" placeholder="请选择">
          <el-option
            v-for="item in electronAccountType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="创建时间" prop="tareWeightTime">
        <el-date-picker
          v-model="form.tareWeightTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
        <el-button type="primary" v-permission="'0210701'" @click="resetAccount">重推电子报账</el-button>
        <el-button type="primary" v-permission="'0210702'" @click="add">新增客户退款申请</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      tooltip-effect="light"
      ref="multipleTable">
      <el-table-column
        prop="receiptNo"
        label="单据编号"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="type"
        label="调账类型"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-show="scope.row.adjustType == '1'">抹零</span>
          <span v-show="scope.row.adjustType == '2'">仓储费手工开票</span>
          <span v-show="scope.row.adjustType == '3'">客户退款</span>
          <span v-show="scope.row.adjustType == '4'">客户间调账</span>
          <span v-show="scope.row.adjustType == '5'">收款冲销</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="currencyType"
        label="币种"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-show="scope.row.currencyType == '1'">CNY</span>
          <span v-show="scope.row.currencyType == '2'">USD</span>
          <span v-show="scope.row.currencyType == '3'">EUR</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="adjustAmount"
        label="调账金额"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="customerName"
        label="客户名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="orgName"
        label="经营组织"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="agreementNo"
        label="协议编号"
        show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column
        prop="grandCustomerName"
        label="增款客户名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="grandAgreementNo"
        label="增款协议编号"
        show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column
        prop="icCardNo"
        label="发起人一卡通号"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="auditStatus"
        label="审核状态"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-show="scope.row.auditStatus == '1'">未审核</span>
          <span v-show="scope.row.auditStatus == '2'">审核通过</span>
          <span v-show="scope.row.auditStatus == '3'">审核不通过</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="推送电子报账状态"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-show="scope.row.adjustType != '5'">
            <span v-show="scope.row.status == '1'">推送失败</span>
           <span v-show="scope.row.status == '2'">已推送</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="createPerson"
        label="操作人"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="auditTime"
        label="审核时间"
        show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <div>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="listState.pageNo"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange">
      </el-pagination>
    </div>
  <add-modal :show.sync="addModalVisible" @onform="forms"  :formData="addData"/>
  <automatic :show.sync="automaticVisible"  @onform="forms" :formData="addData"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import addModal from './addModal'
import AjaxSelect from '../../../components/ajaxSelect/index'
import SearchSelect from '../../../components/searchSelect/index'
// import fundManageApi from '../../../api/fundManageApi'
import MultiCascader from '../../../components/multiCascader/multi-cascader-base-element/multiCascader'
import TagSearchSelect from '../../../components/tagSearchSelect/index'
export default {
  name: 'saleQuery',
  components: { AjaxSelect, MultiCascader, addModal, TagSearchSelect, SearchSelect },
  data () {
    return {
      form: {
        tareWeightTime: []
      },
      tableData: [],
      addData: {},
      auditStatus: '',
      status: '',
      orderType: [
        { value: 3, label: '全部' },
        { value: 3, label: '客户退款' }
      ],
      moneyType: [
        { value: '', label: '全部' },
        { value: 1, label: 'CNY' },
        { value: 2, label: 'USD' },
        { value: 3, label: 'EUR' }
      ],
      auditType: [
        { value: '', label: '全部' },
        { value: 1, label: '未审核' },
        { value: 2, label: '审核通过' },
        { value: 3, label: '审核不通过' }
      ],
      electronAccountType: [
        { value: '', label: '全部' },
        { value: 1, label: '推送失败' },
        { value: 2, label: '已推送' }
      ],
      saleType: [
        { value: 1, label: '全部' },
        { value: 2, label: '经营组织1' },
        { value: 3, label: '经营组织2' }
      ],
      list: [],
      total: 0,
      citisOptions: [],
      listState: {
        pageSize: 10,
        pageNo: 1
      },
      automaticVisible: false,
      addModalVisible: false
    }
  },
  methods: {
    ...mapActions([
      'getAccountAdd',
      'getPush',
      'getAccountList'
    ]),
    handleOrgChange (e) {
      console.log(e)
    },
    onProtocolChange (e) {
      console.log(e)
    },
    handleCusChange (e) {
      console.log(e)
    },
    // 搜索
    handleSearch () {
      console.log('jashjdhashdk')
      const params = {
        adjustType: 3,
        receiptNo: this.form.ces1,
        // typeList: this.form.ces2,
        currencyType: this.form.ces3,
        orgId: this.form.organization,
        customerId: this.form.custom,
        auditStatus: this.form.auditStatus,
        status: this.status,
        // createTimeStart: this.form.tareWeightTime[0].substring(0, 10),
        // createTimeEnd: this.form.tareWeightTime[1].substring(0, 10),
        ...this.listState
      }
      if (this.form.tareWeightTime === null) {
        console.log(this.form.tareWeightTime)
        this.form.tareWeightTime = []
      }
      if (this.form.tareWeightTime.length === 2) {
        params.createTimeStart = this.form.tareWeightTime[0] + ' 00:00:00'
        params.createTimeEnd = this.form.tareWeightTime[1] + ' 23:59:59'
        console.log(params)
      }
      this.getAccountList(params).then(res => {
        console.log(res, '8888')
        const { list, total, pageNum, pageSize } = res
        this.tableData = list
        this.total = total
        this.listState.pageNo = pageNum
        this.listState.pageSize = pageSize
      })
    },
    // 分页条数变更
    handleSizeChange (val) {
      console.log(val)
      this.listState.pageSize = val
      this.handleSearch()
    },
    // 分页跳转
    handleCurrentChange (val) {
      console.log(val)
      this.listState.pageNo = val
      this.handleSearch()
    },
    resetAccount () {
      console.log('888')
      this.getPush().then(res => {
        console.log(res, '8888')
        this.$message.success('重推电子报账成功')
        this.handleSearch()
      })
    },
    add () {
      this.addData = {}
      this.addModalVisible = true
    },
    forms (e) {
      console.log(e)
      const params = {
        adjustType: e.ces1,
        orgId: e.org.id,
        orgName: e.org.name,
        customerId: e.customList[0].id,
        customerName: e.customList[0].name,
        // agreementId: e.protocol ? e.protocol.id : '',
        // agreementNo: e.protocol ? e.protocol.name : '',
        // agreementId: e.protocol,
        agreementNo: e.protocol,
        currencyType: e.ces4,
        adjustAmount: e.ces5,
        icCardNo: e.ces7,
        remark: e.remark
      }
      if (e.ces1 === 4) {
        params.grandCustomerName = e.ces10
        params.grandAgreementNo = e.ces11
      }
      console.log(params)
      this.getAccountAdd(params).then(res => {
        console.log(res, '8888')
        this.$message.success('新增调账成功')
        this.handleSearch()
        // const { list, total, pageNo, pageSize } = res.data
        // this.tableData = list
        // this.listState.total = total
        // this.listState.pageNo = pageNo
        // this.listState.pageSize = pageSize
      })
    },
    // 查询表单，表格重置
    handleReset () {
      this.form.pageNo = 1
      this.form.pageSize = 20000
      this.form.organization = ''
      this.form.custom = ''
      this.form.auditStatus = ''
      this.$refs['form'].resetFields()
      // this.$refs['citisSelector'].reset()
      this.handleSearch()
    }
  },
  mounted () {
    this.isCheckRecord = ''
    this.form.orderTime = ''
    this.handleSearch()
  }
}
</script>

<style scoped>
.output-box{
margin-top: 20px;
text-align: right;
}
.input-page, .select-page{
  width: 98px;
  margin: 0 15px;
}
.input-page, .select-page-btn{
  width: 120px;
  margin: 0 15px;
}
</style>
